import { DataImport, useDataImportQuery } from 'graphql-common';
import { ErrorLike } from '@apollo/client';

type Args = {
  id?: string;
};

export type UseDataImportQueryHookResult = {
  data: DataImport | null | undefined;
  error: ErrorLike | undefined;
  firstLoading: boolean;
  loading: boolean;
  refetch: () => Promise<unknown>;
};

export default function useDataImportQueryHook(
  args: Args,
): UseDataImportQueryHookResult {
  const { id = '' } = args;
  const query = useDataImportQuery({
    skip: !id,
    variables: {
      id,
    },
    fetchPolicy: 'cache-and-network',
  });
  const { data: queryData, refetch, loading, error, previousData } = query;
  const respData = queryData || previousData;
  const data = respData?.data as DataImport;
  const firstLoading = loading && queryData === undefined;

  return {
    data,
    error,
    firstLoading,
    loading,
    refetch,
  };
}
